import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useViewMode } from '../contexts/ViewModeContext';

export function AdvancedOnlyRoute({ children }) {
  const { isAdvanced } = useViewMode();

  if (!isAdvanced) {
    return (
      <Container className="mt-4">
        <Alert variant="info">
          This section is available in Advanced mode. Use the Basic / Advanced switch at the bottom
          of the sidebar to enable it.
        </Alert>
      </Container>
    );
  }

  return children;
}

export default AdvancedOnlyRoute;
